

















































import Vue from "vue";
import Component from "vue-class-component";
import TimestampAgo from "@/components/TimestampAgo.vue";
import CustomSectionHeader from "@/components/CustomSectionHeader.vue";
import VueError from "@/components/VueError.vue";
import Loading from "@/components/Loading.vue";
import {Prop} from "vue-property-decorator";
import tippy from "tippy.js";
import * as _ from "lodash";
import moment from "moment";
import fileDownload from "js-file-download";
import {BaseStationLocation, NTag} from "@/types/ntag";

@Component({
  components: {
    TimestampAgo,
    CustomSectionHeader,
    VueError,
    Loading,
  }
})
export default class BaseStationsList extends Vue {
  @Prop({ default: '', type: String}) locationId!: string;
  @Prop({ default: () => {return []},  type: Array}) baseStations!: string[];
  @Prop({ default: () => {return []},  type: Array}) geoLocations!: BaseStationLocation[];

  error:string = '';


  mounted() {
    tippy('[data-tippy-content]');
  }

  async exportLocationBaseStations() {
    const csvExport = this.bssToCSV(this.baseStations, this.geoLocations);

    const filename = `export-${this.locationId}-base-stations-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  private bssToCSV(bssIds: string[], geoLocations: BaseStationLocation[]): string {
    const retList:string[] = [];

    retList.push(`bssId,lat,long`);

    let index = 0;
    for(const bssId of bssIds) {

      const row = [];
      row.push(this.forceString(bssId));
      row.push(geoLocations[index].lat);
      row.push(geoLocations[index].long);

      index += 1;

      retList.push(row.join(','));
    }

    return retList.join("\n");
  }

  private forceString(data:string):string {
    return `"${data}"`;
  }


  goToBaseStationPage(baseStationId:string) {
    this.$router.push(`/assets/basestation/${baseStationId}`);
  }

  renderGeo(index: number): string {
    return JSON.stringify(_.omit(this.geoLocations[index],"alt"));
  }

  get showItemsTable() {
    return this.baseStations.length > 0;
  }

  get showNoItems() {
    return this.baseStations.length === 0;
  }
}
